import { API_URL } from 'utils/environment';
import { get } from 'utils/request';

export const checkIdentifier = async (email) => {
  const encodedUri = `${API_URL}/users/authentication-info?email=${encodeURIComponent(
    email,
  )}`;
  return get(encodedUri);
};
